import React from "react";

const BuildMachineContext = React.createContext<any | null>(null);

export default BuildMachineContext;
